export default function SelfieSpotCountdown() {
  // Timer removed: component intentionally renders nothing and performs no navigation.
  return null;
}